import React, { useContext, useEffect } from 'react';

import { SaisieContext } from './../../formConteneur';


export const BoutonRetour: React.FC = () => {
  const { modeAffichage, setArrowLeftPressed } = useContext(SaisieContext);

  const handleClick = (/* e: React.MouseEvent */): void => {
    // e.preventDefault();
    // console.log('clic sur bouton Retour');
    setArrowLeftPressed(true);
  }

  useEffect(() => {
    const handleArrowLeft = (event: KeyboardEvent): void => {
      // console.log('modeAffichage= ', modeAffichage);

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        setArrowLeftPressed(true);
      }
    }
    if (modeAffichage) {
      window.addEventListener('keydown', handleArrowLeft);
    } else {
      window.removeEventListener('keydown', handleArrowLeft);
    }
    return (): void => {
      window.removeEventListener('keydown', handleArrowLeft);
    };
  }, [modeAffichage]);

  const ret = <><button
    id="bouton_retour"
    onClick={handleClick}
    className="retour"
    title="Raccourci clavier : Flèche gauche"
    tabIndex={2}
    type="button"
    >
    {/* <img src="../../../images/flecheGauche_9060.png" alt="Smiley face"/> */}
      {/* Etape précédente */}
    </button>
</>;
  return ret;
};
